<template>
  <div class="form-title" >
      <span class="tip1">{{ tip }}</span>
      <span>
        (<span class="tip2" >*</span>为必填项) 未毕业时无需上传学历、学位证书及学历认证报告，若仍无办法保存，请清除浏览器缓存（快捷键：Ctrl+Shift+Delete）或者切换浏览器（建议试用谷歌浏览器）重新访问页面。
      </span>
      <span class="tip3" >
        {{tip3}}
      </span>
  </div>
</template>

<script>
export default {
  name: 'formTitle',
  props: {
    tip: {
      type: String,
      default: '',
    },
    tip3: {
      type: String,
      default: '',
    },
    flag:Boolean
  },
  data() {
    return {
      
    }
  },
}
</script>

<style lang="scss" scoped>


.form-title {

  padding-left: 12px;
  padding-right: 12px;
  padding-top: 12px;
  padding-bottom: 24px;
  background: #fff;
  border-radius: 4px;

  .tip1 {
    font-size: 18px;
    font-weight: bold;
  }

  .tip2 {
    color: red;
    font-size: 12px;
  }

  .tip3 {
    color: red;
    display: block;
    font-size: 12px;
  }



}


@media screen and (min-width: 320px) { 

}

@media screen and (min-width: 480px) { 
    
}
/* 移动 */
@media screen and (min-width: 576px) { 
    
}
/* 平板 */
@media screen and (min-width: 768px) { 
    .form-title {

      .tip1 {
      }

      .tip2 {
      }

      .tip3 {
        color: red;
        display: inline-block;
        vertical-align: center;
      }

    }


}

/* PC */
@media screen and (min-width: 992px) {

}
@media screen and (min-width: 1200px) {

}



</style>
